var render, staticRenderFns
import script from "./resize-sensor.vue?vue&type=script&lang=js&"
export * from "./resize-sensor.vue?vue&type=script&lang=js&"
import style0 from "./resize-sensor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yuya-inagaki/Workspace/personal-works/yukiko-nishimura/html/wp-content/themes/yukiko-nishimura/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0079a024')) {
      api.createRecord('0079a024', component.options)
    } else {
      api.reload('0079a024', component.options)
    }
    
  }
}
component.options.__file = "node_modules/vue-resize-sensor/src/resize-sensor.vue"
export default component.exports